import IUserNotFoundHttpErrorResponse from '../../interfaces/BadRequest/IUserNotFoundHttpErrorResponse';
import BadRequestHttpError from '../BadRequestHttpError';

export default class UserNotFoundHttpError extends BadRequestHttpError<IUserNotFoundHttpErrorResponse> {
    constructor(response: IUserNotFoundHttpErrorResponse) {
        super('User not found!', response);
    }
}
